import classNames from "classnames";
import { Fragment, useEffect, useState } from "react";
import { IoIosArrowBack } from "react-icons/io";
import { RxCross1 } from "react-icons/rx";
import { useLocation } from "react-router-dom";
import SidebarContent from "./SidebarContent";
import style from "./SmallSidebar.module.css";

export default function SmallSidebar() {
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(true);

  useEffect(() => {
    setCollapsed(true);
  }, [location.pathname]);

  return (
    <Fragment>
      {collapsed && (
        <button
          className={classNames("buttonUi", style.showMenuButton)}
          onClick={() => setCollapsed(false)}
        >
          <span>نمایش منو</span>
          <span>
            <IoIosArrowBack />
          </span>
        </button>
      )}

      <div
        className={classNames(
          style.sidebar,
          collapsed ? "" : style.sidebarShow
        )}
      >
        <button
          className={classNames(
            "buttonUi",
            style.showMenuButton,
            style.closeButton
          )}
          onClick={() => setCollapsed(true)}
        >
          <span>بستن منو</span>
          <span className="me-1">
            <RxCross1 />
          </span>
        </button>

        <SidebarContent />
      </div>
    </Fragment>
  );
}
